import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
} from '@material-ui/core';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import LightbulbCircleRoundedIcon from '@mui/icons-material/LightbulbRounded';
import { Box, Divider, Typography } from '@mui/material';
import { ALL_LEGENDS_DATA } from 'modules/CommonView/components/Legend/constants';

import { useState } from 'react';

import { useStyles } from './Style';

const SugarcaneLegend = () => {
	const classes = useStyles();
	const [isLegendVisible, setIsLegendVisible] = useState(false);

	const toggleLegend = () => {
		setIsLegendVisible((prevState) => {
			return !prevState;
		});
	};

	return (
		<Accordion className={classes.legendHead}>
			<AccordionSummary
				// className={classes.legendHead}
				expandIcon={
					isLegendVisible ? (
						<ExpandLess style={{ color: '#FFFFFF' }} />
					) : (
						<ExpandMore style={{ color: '#FFFFFF' }} />
					)
				}
				onChange={toggleLegend}
			>
				<Box display="flex">
					<LightbulbCircleRoundedIcon
						sx={{
							color: '#FFFDC3',
						}}
					/>
					<Typography marginLeft="5px"> Legend</Typography>
				</Box>
			</AccordionSummary>

			<AccordionDetails className={classes.LegendItemsDivParent}>
				{ALL_LEGENDS_DATA.map((group, index) => (
					<Box key={index}>
						{index !== ALL_LEGENDS_DATA.length - 1 && (
							<Divider
								sx={{
									color: '#ffffff',
									backgroundColor: '#ffffff',
									margin: '10px 0',
								}}
							/>
						)}
						{group.map((data) => {
							return (
								<Box
									key={data.title}
									marginTop="5px"
									marginBottom="5px"
								>
									<Box>
										<Typography>{data.title}</Typography>
									</Box>
									{data.icons?.map((icon: any) => (
										<Box
											key={icon.title}
											display="flex"
											marginTop="2px"
										>
											<div
												style={{
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center',
													height: 28,
													width: 28,
												}}
											>
												<img
													className={
														classes.IconImages
													}
													src={icon.iconUrl}
													alt={icon.title}
													style={{
														height: icon.height,
														width: icon.width,
													}}
												/>
											</div>
											<span className={classes.IconTexts}>
												{icon.title}
											</span>
										</Box>
									))}
								</Box>
							);
						})}
						{index !== ALL_LEGENDS_DATA.length - 1 && (
							<Divider
								sx={{
									color: '#ffffff',
									backgroundColor: '#ffffff',
									margin: '10px 0',
								}}
							/>
						)}
					</Box>
				))}
			</AccordionDetails>
		</Accordion>
	);
};

export default SugarcaneLegend;
